import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",

  initialState: {
    user: null,
    role: null,
    token: null,
    isLoggedIn: false,
    // Claude: verification fields — set at login, used by layouts for access control 26-02-2026
    verificationStatus: null as string | null,
    verificationDeadline: null as string | null,
    // Claude: display name — personName (Seller) or buyerPersonName (Buyer), set at login 11-03-2026
    name: null as string | null,
  },

  reducers: {
    setUser: (state: any, action) => {
      state.user = action.payload.user;
      state.role = action.payload.role;
      state.token = action.payload.token;
      state.isLoggedIn = true;
      // Claude: persist verification fields from login response 26-02-2026
      state.verificationStatus = action.payload.verificationStatus ?? null;
      state.verificationDeadline = action.payload.verificationDeadline ?? null;
      // Claude: persist display name for AI chat greeting 11-03-2026
      if (action.payload.name !== undefined) state.name = action.payload.name ?? null;
    },
    logout: (state: any) => {
      state.user = null;
      state.role = null;
      state.token = null;
      state.isLoggedIn = false;
      state.verificationStatus = null;
      state.verificationDeadline = null;
      state.name = null;
    },
    changeToken: (state, action) => {
      state.token = action.payload.token;
    },
    // Claude: refresh verificationStatus without full re-login — used on dashboard mount 10-03-2026
    setVerificationStatus: (state: any, action) => {
      state.verificationStatus = action.payload.verificationStatus ?? state.verificationStatus;
      state.verificationDeadline = action.payload.verificationDeadline ?? state.verificationDeadline;
    },
  },
});

export const { setUser, logout, changeToken, setVerificationStatus } = userSlice.actions;

export const reducer = userSlice.reducer;
